function ModalHeader({ children }) {
    return children;
}
export { ModalHeader };
